export default "__VITE_ASSET__D5KeL4ie__"